import { QuestionsValidators, ValidationResultTuple } from '../types';

export default (currentPageValidators: QuestionsValidators, questionId?: string): ValidationResultTuple | null => {
  if (questionId) {
    return currentPageValidators[questionId]?.lastResult ?? null;
  }

  const questionIds = Object.keys(currentPageValidators);

  return questionIds.reduce<ValidationResultTuple>(
    (state, id) => {
      const [pageIsValid, messages] = state;
      const [answerIsValid, validationMessages] = currentPageValidators[id]?.lastResult ?? [];

      return [pageIsValid && (answerIsValid ?? false), [...(messages ?? []), ...(validationMessages ?? [])]];
    },
    [true, []]
  );
};
